import { useSelector } from "react-redux";
import PropertyDetailCard from "../PropertyDetailCard";
import Notification from "../../../../components/common/notification/Notification";
import { getUserDisplayName } from "../../../navigation/adminNavigation";

const Step5Preview = ({ form, onUpdate, prevStep, onSubmit, isSubmitting = false }) => {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user;

  const creatorName =
    getUserDisplayName(authState) ||
    `${loggedInUser?.user?.firstName || loggedInUser?.first_name || ""} ${loggedInUser?.user?.lastName || loggedInUser?.last_name || ""}`.trim() ||
    loggedInUser?.name ||
    "Owner";

  return (
    <div>
      <Notification />
      
      <PropertyDetailCard
        name={form.name}
        address={form.address}
        land_mark={form.area}
        pin_code={form.pin_code}
        city={form.cityName}
        state={form.stateName}
        country={'India'}
        structure={form.structure || {}}
        description={form.description || ""}
        feature={form.feature || {}}
        price={form.price || ""}
        propertyPurpose={form.propertyPurposeName}
        propertyType={form.propertyTypeName}
        property_sub_type={form.propertySubtypeName || ""}
        property_sub_sub_type={form.propertySubSubTypeName || ""}
        images={form.images} 
        videos={form.videos}  
        attachments={form.attachments}
        creater={creatorName}
        photo={form.photo}
      /> 
      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={prevStep} disabled={isSubmitting}>
          Previous
        </button>
        <div className='d-flex gap-3'>
          <button className="btn btn-warning" onClick={onUpdate} disabled={isSubmitting}>
            Edit Form
          </button>
          <button className="btn btn-success" onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Publishing Property..." : "Submit Property"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step5Preview;